import React, { useMemo } from 'react';
import { titlePaths } from '@warehouse/title/core';
import { TitleTextInputField } from '@warehouse/title/ui';

export function TitleDisplay60Field({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.titleDisplay60(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextInputField label="Short Title" ariaLabel="Short Title Field" path={path} />;
}
